import { Skeleton, Table } from 'antd';
import { TablePaginationConfig, ExpandableConfig } from 'antd/es/table/interface';
import React from 'react';
import { Delivery } from '../../api/models/deliveries';
import EmptyPage, { EMPTY_PAGE_USECASE } from '../../screens/pageNotFound/EmptyPage';
import { routes } from '../../utils/routerHelper';
import { useHistory } from 'react-router-dom';

type DeliveriesTableProps = {
  columns: any[];
  dataSource: any[];
  onChange: (pagination: TablePaginationConfig) => void;
  pagination: {
    defaultPageSize: number;
    total: number;
  };
  expandable: ExpandableConfig<Delivery> | undefined;
  isEmpty: boolean;
  isLoading: boolean;
  emptyUseCase: EMPTY_PAGE_USECASE;
  emptyHasCta: boolean;
};

const DeliveriesTable: React.FC<DeliveriesTableProps> = ({
  columns,
  dataSource,
  onChange,
  pagination,
  expandable,
  isEmpty,
  isLoading,
  emptyUseCase,
  emptyHasCta
}) => {
  const { push: historyPush } = useHistory();
  return isLoading ? (
    <Skeleton active paragraph={{ rows: 8 }} />
  ) : isEmpty ? (
    <EmptyPage
      useCase={emptyUseCase}
      hasCTA={emptyHasCta}
      ctaAction={() => {
        historyPush(routes.deliveriesDetailed);
      }}
    />
  ) : (
    <Table
      rowKey={'id'}
      columns={columns}
      dataSource={dataSource}
      onChange={onChange}
      pagination={{
        defaultPageSize: pagination.defaultPageSize,
        position: ['bottomCenter'],
        total: pagination.total,
        simple: true,
        showSizeChanger: false
      }}
      expandable={expandable}
    />
  );
};

export default DeliveriesTable;
